import React, { useState } from 'react';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { Button, notification, Space, Dropdown } from "antd";
import { FileExcelOutlined, FileTextOutlined, DownloadOutlined } from "@ant-design/icons";

const ExportNovedades = ({ dataCompleta }) => {
  const [loadingExcel, setLoadingExcel] = useState(false);
  const [loadingJson, setLoadingJson] = useState(false);

  const exportToExcel = async () => {
    try {
      if (dataCompleta.length === 0) {
        notification.warning({
          message: "Advertencia",
          description: "No hay datos disponibles para exportar.",
          duration: 3
        });
        return;
      }
      setLoadingExcel(true);
      const workbook = new ExcelJS.Workbook();
      const templateResponse = await fetch("/assets/plantilla_novedades.xlsx");
      const templateBuffer = await templateResponse.arrayBuffer();
      await workbook.xlsx.load(templateBuffer);
      const worksheet = workbook.getWorksheet(1);
      let currentRow = 3;

      dataCompleta.forEach((item) => {
        worksheet.getCell(`A${currentRow}`).value = item.codigoSIRR || '';
        worksheet.getCell(`B${currentRow}`).value = item.fecha_registro || '';
        worksheet.getCell(`C${currentRow}`).value = item.nombreParticipante || '';
        worksheet.getCell(`D${currentRow}`).value = item.numeroIdentificacion || '';
        worksheet.getCell(`E${currentRow}`).value = item.nombreProyecto || '';
        worksheet.getCell(`F${currentRow}`).value = item.departamento || '';
        worksheet.getCell(`G${currentRow}`).value = item.municipio || '';
        worksheet.getCell(`H${currentRow}`).value = item.vereda || '';
        worksheet.getCell(`I${currentRow}`).value = item.codigoPREPP || '';
        worksheet.getCell(`J${currentRow}`).value = item.descripcionProyecto || '';
        worksheet.getCell(`K${currentRow}`).value = item.novedad || '';

        //Datos actuales  
        worksheet.getCell(`L${currentRow}`).value = item.sector_economico || '';
        worksheet.getCell(`M${currentRow}`).value = item.actividad_productiva || '';
        worksheet.getCell(`N${currentRow}`).value = item.nombreProyecto || '';
        worksheet.getCell(`O${currentRow}`).value = item.descripcionProyecto || '';

        //Datos a cambiar  
        worksheet.getCell(`P${currentRow}`).value = item.name_sector_economico_cambio || '';
        worksheet.getCell(`Q${currentRow}`).value = item.name_actividad_productiva_cambio || '';
        worksheet.getCell(`R${currentRow}`).value = item.nombreProyecto_cambio || '';
        worksheet.getCell(`S${currentRow}`).value = item.descripcionProyecto_cambio || '';

        worksheet.getCell(`T${currentRow}`).value = item.descripcionNovedad || '';
        worksheet.getCell(`U${currentRow}`).value = item.departamentoNovedad || '';
        worksheet.getCell(`V${currentRow}`).value = item.municipioNovedad || '';
        worksheet.getCell(`W${currentRow}`).value = item.diasNovedad || '';
        worksheet.getCell(`X${currentRow}`).value = item.mesNovedad || '';
        worksheet.getCell(`Y${currentRow}`).value = item.anioNovedad || '';
        worksheet.getCell(`Z${currentRow}`).value = item.user_email || '';
        worksheet.getCell(`AA${currentRow}`).value = item.fuente || '';

        currentRow++;
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, "Informe_Novedades.xlsx");
      notification.success({ message: "Éxito", description: "Excel exportado correctamente.", duration: 3 });
    } catch (error) {
      console.error("Error al generar Excel:", error);
      notification.error({ message: "Error", description: "No se pudo exportar el Excel.", duration: 3 });
    } finally {
      setLoadingExcel(false);
    }
  };

  const exportToJSON = async () => {
    try {
      if (!dataCompleta || dataCompleta.length === 0) {
        notification.warning({ message: "Advertencia", description: "No hay datos disponibles para exportar.", duration: 3 });
        return;
      }
      setLoadingJson(true);
      const jsonBlob = new Blob([JSON.stringify(dataCompleta, null, 2)], { type: "application/json" });
      saveAs(jsonBlob, "Informe_Novedades.json");
      notification.success({ message: "Éxito", description: "JSON exportado correctamente.", duration: 3 });
    } catch (error) {
      console.error("Error al generar JSON:", error);
      notification.error({ message: "Error", description: "No se pudo exportar el JSON.", duration: 3 });
    } finally {
      setLoadingJson(false);
    }
  };

  const menuItems = [
    {
      key: "excel",
      label: (
        <Button
          type="text"
          icon={<FileExcelOutlined />}
          onClick={exportToExcel}
          loading={loadingExcel}
          disabled={loadingExcel}
        >
          Exportar a Excel
        </Button>
      )
    },
    {
      key: "json",
      label: (
        <Button
          type="text"
          icon={<FileTextOutlined />}
          onClick={exportToJSON}
          loading={loadingJson}
          disabled={loadingJson}
        >
          Exportar a JSON
        </Button>
      )
    }
  ];

  return (
    <Space>
      <Dropdown menu={{ items: menuItems }} placement="bottomLeft" trigger={["click"]}>
        <Button  type="primary" icon={<DownloadOutlined />}>Exportar</Button>
      </Dropdown>
    </Space>
  );
};

export default ExportNovedades;